export default __webpack_public_path__ + "static/headerLogo-e1cda9e7123aca735f3ec181ef69e10c.svg";